import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NgModel, ValidationErrors, Validator } from '@angular/forms';
import { DatenabfrageAbregelbareLeistungLowerEqualsInstallierteValidatorDirective }
    from './datenabfrage-abregelbare-leistung-lower-equals-installierte-validator.directive';

/**
 * If the abregelbareLeistungKhas an error set, but the installierteLeistungKW gets changed in a manner,
 * that the error becomes invalid, this directive resets the error in the abregelbareLeistungKW FormControl
 *
 * Checks that the "Abregelbare Leistung EEG/KWKG" is not greater than the "installierte Leistung EEG/KWKG" for
 * the report of Aufteilungsschluessel for a Datenabfrage
 */
@Directive(
    {
        selector: '[tnbResetDatenabfrageAbregelbareLeistungErrorWhenInstallierteChanged]',
        providers: [
            {
                provide: NG_VALIDATORS,
                useExisting: ResetDatenabfrageAbregelbareLeistungErrorWhenInstallierteChangedValidatorDirective,
                multi: true,
            },
        ],
        standalone: false,
    },
)
export class ResetDatenabfrageAbregelbareLeistungErrorWhenInstallierteChangedValidatorDirective implements Validator {

    @Input() tnbResetDatenabfrageAbregelbareLeistungErrorWhenInstallierteChanged: NgModel;

    validate(installierteLeistungControl: AbstractControl): ValidationErrors | null {

        const abregelbareLeistungNgModel = this.tnbResetDatenabfrageAbregelbareLeistungErrorWhenInstallierteChanged;

        if (installierteLeistungControl.value !== null && typeof installierteLeistungControl.value !== 'undefined') {
            const key = DatenabfrageAbregelbareLeistungLowerEqualsInstallierteValidatorDirective.ERROR_KEY;
            if (abregelbareLeistungNgModel.value !== null && typeof abregelbareLeistungNgModel.value !== 'undefined') {
                if (parseFloat(installierteLeistungControl.value) >= parseFloat(abregelbareLeistungNgModel.value)) {
                    if (abregelbareLeistungNgModel.errors !== null) {
                        delete abregelbareLeistungNgModel.errors[key];
                        abregelbareLeistungNgModel.control.setErrors(null);
                        abregelbareLeistungNgModel.control.markAsTouched();
                    }
                } else {
                    const obj = { [key]: true };
                    abregelbareLeistungNgModel.control.setErrors(obj);
                    abregelbareLeistungNgModel.control.markAsTouched();
                }
            }
        }
        return null;
    }

}
